import Icon from '../components/Icon.vue'

Icon.register({
  'record-vinyl': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 152c57.4 0 104 46.6 104 104s-46.6 104-104 104-104-46.6-104-104 46.6-104 104-104zM256 280c13.2 0 24-10.8 24-24s-10.8-24-24-24-24 10.8-24 24 10.8 24 24 24zM256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 384c70.7 0 128-57.3 128-128s-57.3-128-128-128-128 57.3-128 128 57.3 128 128 128z'
      }
    ]
  }
})
